<template>
    <form
            @submit="checkForm"
    >
      <div class="p-20">
        <div class="row">
          <div class="col-md-6">
            <h4>Adresse eingeben</h4>
            <div class="row">
              <div class="col-md-4">
                <VueInputUi id="zip"  v-model="privateState.zip" :color="defaultColor" :required="true" label="Postleitzahl" :error="formErrors.zip"></VueInputUi>
              </div>
              <div class="col-md-8">
                <VueInputUi id="city" v-model="privateState.city" :color="defaultColor" :required="true"  label="Ort" :error="formErrors.city"></VueInputUi>
              </div>
            </div>
            <div class="row mt-10">
              <div class="col-md-8">
                <VueInputUi id="street" v-model="privateState.street" :color="defaultColor" :required="true"  label="Straße" :error="formErrors.street"></VueInputUi>
              </div>
              <div class="col-md-4">
                <VueInputUi id="streetNo" v-model="privateState.streetNo" :color="defaultColor" :required="true" label="Hausnummer"   :error="formErrors.streetNo"></VueInputUi>
              </div>
            </div>
            <div class="row mt-10">
              <div class="col-md-3">
                <VueInputUi id="door" v-model="privateState.door" :color="defaultColor"  label="Tür"></VueInputUi>
              </div>
              <div class="col-md-3">
                <VueInputUi id="stair" v-model="privateState.stair" :color="defaultColor"  label="Stiege"></VueInputUi>
              </div>
              <div class="col-md-3">
                <VueInputUi id="floor" v-model="privateState.floor" :color="defaultColor"  label="Stock"></VueInputUi>
              </div>
              <div class="col-md-3">
                <VueInputUi id="block" v-model="privateState.block" :color="defaultColor"  label="Block"></VueInputUi>
              </div>
            </div>
            <div v-if="state.responseError" class="badge badge-warning" style="margin-top:10px;"><i class="fa fa-info-circle"></i> Ihre Eingaben erzielten keinen Treffer. Bitte überprüfen Sie die Daten.</div>
          </div>
          <div class="col-md-6 text-center pt50">
            <button class="btn btn-default" type="submit"><i class="fa fa-chevron-right"></i> Adresse suchen</button>
            <button class="btn btn-abort mt-10" type="button" v-on:click="hidePanel"><i class="fa fa-times"></i> Abbrechen</button>

          </div>
        </div>
      </div>
    </form>
</template>

<script>
import VueInputUi from "vue-input-ui"
import { mapMutations } from 'vuex'
import axios from 'axios';

var defaultErrors = {
  city: false,
  zip: false,
  street: false,
  streetNo: false
}




export default {
  name: 'LocationForm',
  components: {VueInputUi},
  methods: {
      ...mapMutations([
              'setPanelComponent',
              'setLocations',
              'setResponseError',
              'hidePanel',
              'showLoading',
              'hideLoading',
              'saveLocation'
      ]),
      checkForm: function(e){
        e.preventDefault();
          this.$data.formErrors = Object.create(defaultErrors);
          if(!this.privateState.city){
            this.$data.formErrors.city = true;
          }
          if(!this.privateState.zip){
            this.$data.formErrors.zip = true;
          }
          if(!this.privateState.street){
            this.$data.formErrors.street = true;
          }
          if(!this.privateState.streetNo){
            this.$data.formErrors.streetNo = true;
          }
          for(var i in this.$data.formErrors){
            if(this.$data.formErrors[i] == true){
              return;
            }
          }
          this.checkLocation();
      },
      checkLocation: function(){
        var $this = this;
          $this.showLoading();
          this.saveLocation($this.privateState);
          axios.post(inetApiLink,this.privateState).then(function(response){

              $this.hideLoading()
              switch(response.data.status){
                case 'multiple':
                  $this.setLocations(response.data.locations);
                  $this.setPanelComponent('MultipleForm');
                  break;
                case 'error':
                  $this.setResponseError(response.data.message);
                  break;
                case 'success':
                  document.location.reload();
                  break;
              }
          })
      }
  },
  data() {
    return{
      defaultColor: "#ffb302",
      formErrors: Object.create(defaultErrors),
      privateState : this.$store.state.locationSafe,
      state: this.$store.state
  }},
  props: {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .mt-10{
    margin-top: 10px;
  }
  .pt50{
    padding-top: 50px;
  }
  input{
    z-index: 1;
  }
  label{
    z-index: -1;
  }
  .btn-default{
    background: #fac800;
    min-width: 300px;
    font-size: 1em;
  }
  .btn-abort{
    min-width: 300px;
    font-size: 1em;
  }
  .badge-warning{
    padding: 10px;
  }

</style>
